module.exports = __webpack_public_path__ + "static/how-to-pay-2-0836c6c95137b5afc3c4e50ea95e9956.png";